import { ApplicationRef, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    showLoader = false;

    constructor(private appRef: ApplicationRef) {}

    openLoader() {
        this.showLoader = true;
        setTimeout(() => this.appRef.tick());
    }

    hideLoader() {
        this.showLoader = false;
        setTimeout(() => this.appRef.tick());
    }

    getLoader() {
        return this.showLoader;
    }
}
